// extracted by mini-css-extract-plugin
module.exports = {"sp-175w-B":"B_sp-175w-B__3TU9V"};